module.exports = __webpack_public_path__ + "static/media/remera.32e9e5a9.png";